"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminSchema = exports.OAdmin = exports.IAdminReset = exports.IAdmin = exports.IAdminMinimum = void 0;
const runtypes_1 = require("runtypes");
const mongoose_1 = __importDefault(require("mongoose"));
const misc_1 = require("./misc");
exports.IAdminMinimum = (0, runtypes_1.Record)({
    email: misc_1.Email,
});
exports.IAdmin = exports.IAdminMinimum.extend({
    password: misc_1.Password,
});
exports.IAdminReset = exports.IAdmin.extend({
    newPassword: misc_1.Password,
});
exports.OAdmin = (0, runtypes_1.Record)({
    id: runtypes_1.String,
    loggedIn: runtypes_1.Boolean,
    email: runtypes_1.String,
    resetPassword: runtypes_1.Boolean,
});
exports.AdminSchema = new mongoose_1.default.Schema({
    email: { type: String, unique: true, required: true },
    password: { type: String, required: true },
    temporaryPassword: String,
    forgotPassword: { type: Boolean, required: true, default: false },
});
